
import { TranslationRecord } from '../../types';

export const legal: TranslationRecord = {
  // Legal & Help
  legalHelp: 'Legal & Help',
};
